export const MODAL_NAMES = {
  LEARN_MORE: {
    SERVICE_MODAL: 'service-modal',
    INSURANCE_MODAL: 'insurance-modal',
    INSURANCE_PREMIUM_MODAL: 'insurance-premium-modal',
  },
}

export const DEFAULT_INSURANCE_ID = '0'
